
import React from "react";
import {ModalWrapper, Reoverlay} from "reoverlay";
import 'reoverlay/lib/ModalWrapper.css';
import Button from "../Button";

import { FaRegQuestionCircle } from "react-icons/fa";
const ConfirmModal=(props)=>{
    const handleConfirm=()=>{
        if(props.onConfirm){
            props.onConfirm()
        }
    }
    const handleCancel=()=>{
        if(props.onCancel){
            props.onCancel();
            Reoverlay.hideModal();
        }
    }

    return <ModalWrapper  onClose={()=>{}}  animation="slideDown" contentContainerClassName="w-11/12 flex flex-col justify-center items-center flex-col md:8/12 lg:w-4/12 p-5 rounded-xl">
        <FaRegQuestionCircle className="text-5xl text-blue-300 mb-5"/>
        <h1 className="text-xl  font-bold  text-gray-700 text-center ">{props.title}</h1>
        <p className="text-gray-700 text-center mb-3 ">{props.message}</p>
        <div className={`w-full mt-2 grid gap-2  grid-cols-${(props.showConfirmButton && props.showCancelButton) ? 2:1}`}>
            {props.showConfirmButton && <Button onClick={handleConfirm} rounded="rounded-lg" theme={props.confirmButtonTheme || "light"} className="text-sm">{props?.confirmButtonText||'باشه'}</Button> }
            {props.showCancelButton && <Button onClick={handleCancel}  rounded="rounded-lg" theme={props.cancelButtonTheme || "green"} className="text-sm">{props?.cancelButtonText||'بستن'}</Button> }
        </div>


    </ModalWrapper>
}
export default ConfirmModal;